module.exports = __webpack_public_path__ + "img/logo_agent.d55ae7ac.png";